import styled from 'styled-components';

export const DeleteBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${(props) => props.theme.colors['neutral-80']};
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 12px;
  transition: color 0.3s ease;

  &:hover {
    color: ${(props) => props.theme.colors.warning};
  }

  & > svg {
    width: 12px;
  }
`;
